import React, { Fragment } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import BottomNavigation, {
  BottomNavigationAction
} from "material-ui/BottomNavigation";
import orange from "material-ui/colors/orange";
import { withStyles } from "material-ui/styles";

import BackButton from "components/BackButton";

const styles = theme => ({
  container: {
    padding: 20,
    margin: "20px auto",
    width: 1100,
  },
  header: {
    display: "flex"
  },
  title: {
    margin: 0
  },
  main: {
    padding: 20,
    minHeight: 200
  },
  soloLocale: {
    pointerEvents: "none"
  },
  selectedNavItem: {
    color: "#fff",
    backgroundColor: theme.palette.secondary.main
  },
  naviContent: {
    margin: "0 20px"
  },
  labelDiv: {
    marginTop: 20
  },
  label: {
    fontSize: "1.1rem",
    fontWeight: 700
  },
  note: {
    display: "inline",
    fontSize: "0.9rem",
    marginLeft: 20
  },
  rowWrapper: {
    margin: "10px 0 20px"
  },
  row: {
    display: "flex",
    marginBottom: 5
  },
  markArea: {
    minWidth: 20
  },
  mark: {
    color: orange[700]
  },
  line: {
    display: "flex",
    padding: "0 5px",
    borderBottom: "1px solid gray"
  },
  additionWrapper: {
    marginLeft: 20
  },
  qNo: {
    whiteSpace: "pre"
  },
  choices: {
    margin: "0 20px 10px"
  },
  freeCommentDescription: {
    marginLeft: 20,
    marginBottom: 10
  }
});

class SurveyCheckWord extends React.Component {
  componentDidMount() {
    this.props.fetchSurveyWord();
  }

  componentWillUnmount() {
    this.props.init();
  }

  render() {
    // sytles
    const { classes } = this.props;
    // state
    const {
      survey,
      selectedLocaleKey,
      locales,
      questions,
      additionLocales,
      freeCommentDescription1,
      freeCommentDescription2
    } = this.props;
    // action
    const { moveToPreview, changeLocale } = this.props;

    return (
      <Paper className={classes.container}>
        <div className={classes.header}>
          <h2 className={classes.title}>設問チェック</h2>
          <BackButton />

          <Button raised onClick={moveToPreview(survey)}>
            プレビュー
          </Button>
        </div>

        <div className={classes.main}>
          <BottomNavigation
            value={selectedLocaleKey}
            showLabels
            onChange={changeLocale}
          >
            {locales.map(locale => (
              <BottomNavigationAction
                key={locale.id}
                value={locale.key}
                label={locale.jaLabel}
                className={classnames(
                  locales.length <= 1 ? classes.soloLocale : null,
                  locale.key === selectedLocaleKey
                    ? classes.selectedNavItem
                    : null
                )}
              />
            ))}
          </BottomNavigation>

          <div className={classes.naviContent}>
            <div className={classes.labelDiv}>
              <span className={classes.label}>基本設問</span>
              <div className={classes.note}>
                ※編集された設問には<span className={classes.mark}> ＊ </span>がつきます
              </div>
            </div>

            <div className={classes.rowWrapper}>
              {questions.map(row => (
                <div key={row.qNo} className={classes.row}>
                  <div className={classes.markArea}>
                    <span className={classes.mark}>
                      {row.changed ? "＊" : ""}
                    </span>
                  </div>
                  <div className={classes.line}>
                    <span className={classes.qNo}>{row.qNo}. </span>
                    <span>{row.text}</span>
                  </div>
                </div>
              ))}
            </div>

            {additionLocales.length > 0 && (
              <Fragment>
                <div className={classes.label}>追加設問</div>
                <div className={classes.rowWrapper}>
                  <div className={classes.additionWrapper}>
                    {additionLocales.map(addition => (
                      <div key={addition.qNo}>
                        <div className={classes.markArea} />
                        <div className={classes.line}>
                          <span className={classes.qNo}>{addition.qNo}. </span>
                          <span>{addition.text}</span>
                        </div>

                        <div className={classes.choices}>
                          {addition.choices
                            .map(choice => `・${choice.label}`)
                            .join(" ")}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </Fragment>
            )}

            {freeCommentDescription1 && (
              <Fragment>
                <div className={classes.label}>自由記入１の説明</div>
                <div className={classes.freeCommentDescription}>
                  {freeCommentDescription1}
                </div>
              </Fragment>
            )}

            {freeCommentDescription2 && (
              <Fragment>
                <div className={classes.label}>自由記入２の説明</div>
                <div className={classes.freeCommentDescription}>
                  {freeCommentDescription2}
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </Paper>
    );
  }
}

SurveyCheckWord.defaultProps = {
  selectedLocaleKey: null
};

SurveyCheckWord.propTypes = {
  classes: PropTypes.object.isRequired,
  selectedLocaleKey: PropTypes.string,
  locales: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  questions: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  additionLocales: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  moveToPreview: PropTypes.func.isRequired,
  changeLocale: PropTypes.func.isRequired
};

export default withStyles(styles)(SurveyCheckWord);



// WEBPACK FOOTER //
// ./src/components/SurveyCheckWord.jsx